import React from "react";

const janhavi_jain = () => {
  return (
    <div>
      <h1>Janhavi Jain</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        There was online aptitude test (could be given from anywhere)
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        Aptitude Test Date : July 27th
        <br />
        Shortlisting Date : July 30th (29 students shortlisted)
        <br />
        Interview Date : August 2nd (3 technical rounds and 3 were selected)
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        The aptitude round included (some that I remember):
      </p>

      <ol>
        <li>
          conceptual mathematics: geometry vector algebra, matrix operations{" "}
        </li>
        <li>logical reasoning. </li>
        <li>programming-based problem-solving: debugging and code output. </li>
        <li>
          scenario-based question on how the candidate tackles some real world
          situations.{" "}
        </li>
        <li>
          3 coding questions: recursion &amp; backtracking , DFS , AVL Trees.
        </li>
      </ol>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />
        29 students
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        During the 2-day wait period, I focused my preparation on four main
        areas:
        <br />
        Leetcode questions.
        <br />
        Internship Summary: Prepared a thorough overview of my internship'25
        project, including architecture and tech stack.
        <br />
        Resume Revision: Quickly revised core subjects listed on my resume: CN,
        DBMS, DSA, and OOP.
        <br />
        Mock Interviews: Conducted mock sessions with friends, specifically
        asking them to pose deep questions about my projects.
        <br />A calm and well-rested mind is just as crucial as the technical
        preparation itself.
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />
        3 rounds (all technical)
        <br />
        Round I (45–50 mins):
        <br />
        This round focused on DSA and problem-solving.
        <br />
        I was presented with a scenario-based DSA question.
        <br />
        The interviewer asked me to first think about the appropriate data
        structure to store the data and then the right one to solve the problem
        (it turned out to be hashmap-based).
        <br />I was also prompted to consider and discuss various edge cases.
      </p>

      <p>
        Round II (1hr):
        <br />
        It began with a detailed discussion about my project on student record
        management using B+ Trees. It evolved into more of a debate about the
        scenarios where that specific data structure is most useful. This
        transitioned into a Computer Organization discussion, specifically about
        disk access, which naturally related back to B+ Trees.
        <br />
        I was also quizzed on OS fundamentals, whatever topics had been covered
        in my college curriculum up to that point.
        <br />
        Next came a question on Graphs. The round concluded with a low-level
        exercise: I had to write a small C code snippet of my choice and then
        convert it into assembly code.
      </p>

      <p>
        Round III (50mins):
        <br />
        It started with another DSA question that required the use of a
        monotonic stack and a hashmap. I was then asked several questions about
        my summer internship in 2025.
      </p>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        From resume: DSA(heavily focused), B+ Trees (since it was the core of my
        project), Spring Boot and general project architecture (due to my
        internship experience).
        <br />
        Outside resume: OS, CO, including assembly code for C code.
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />
        The resources I found most helpful for preparing were:
        <br />
        Striver's resources for DSA(Striver’s A2Z sheet mainly).
        <br />
        Discussing questions and problems with friends, this helps a lot for
        clearing concepts and finding different approaches.
        <br />
        GFG for quick revisions of various topics.
        <br />
        Standard textbooks for the fundamentals of respective subjects (e.g,
        Kurose for CN).
      </p>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        Stay calm.
        <br />
        Think out loud. Verbalize your thought process, even if you feel you
        might be heading in the wrong direction. Letting the interviewer know
        your reasoning and where you might have gotten stuck is crucial, as they
        might provide a subtle hint.
        <br />
        Be confident in your approach and your knowledge.
        <br />
        If you are not certain about the question, ask questions to clarify your
        doubts.
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />I was asked detailed questions about one of my projects(DSA) and
        Internship of summer 2025. However, there were no questions at all about
        my clubs or extracurricular activities.
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        You need to be very well prepared for all sorts of technical questions,
        even on subjects not explicitly mentioned in your resume (like CO/OS was
        for me).
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        The internship cycle can be very tough at times to cope with.
        <br />
        Avoid comparing yourselves to your peers, that can make things much
        worse.
        <br />
        Instead, use that energy as a good motivator to level up your own
        skills.
        <br />
        Focus on your journey (I know it’s easier said than done) but prepare
        for the worst, and hope for the best!
      </p>

      <p>
        <strong>Contact Info </strong>
        <br />
        <strong>Email :</strong> <a href="mailto:jainjp23.comp@coeptech.ac.in">jainjp23.comp@coeptech.ac.in</a>
        <br />
        <strong>LinkedIn :</strong>{" "}
        <a href="https://www.linkedin.com/in/janhavi-jain-53b67a285"> Janhavi Jain</a>
      </p>
    </div>
  );
};

export default janhavi_jain;
